@if(loader){
    <app-loader></app-loader>
    }
    <p-card header="">

         <div class="flex justify-content-between align-items-center flex-wrap w-100 position-relative">
        <div class="flex align-items-center">
            <div>
                <p-button label="New" (click)="open()" class="p-button-outlined ml-2 " icon="pi pi-plus" size="small"
                    pTooltip="Add GST"></p-button>
                </div>
                
                <div class="flex align-items-center ml-3">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" [(ngModel)]="searchKey" [placeholder]="placeholder" class="p-inputtext-sm"
                            (keyup.enter)="searchGST()" style="height: 35px; font-size: 0.875rem; padding-left: 2rem;" />
                    </span>
                    <p-button icon="pi pi-search" (onClick)="searchGST()" [raised]="true" [size]="'small'" severity="info" class="ml-2"
                        [ngStyle]="{ height: '35px' }"></p-button>
                </div>
                
                @if(selectedGST.length > 0){
                    <p-button label="Edit" *ngIf="selectedGST && selectedGST.length == 1" (onClick)="edit()" class="p-button-outlined ml-2 "
                    icon="pi pi-user-edit" severity="secondary" size="small"></p-button>
                    <p-button label="Delete" (onClick)="delete()" class="p-button-outlined ml-2" icon="pi pi-trash" severity="danger"
                        size="small"></p-button>
                }
                </div>
                <h2 class="page-title-center">GST List</h2>
                
                
                <div class="flex">
                    <div class="flex align-items-center">
                        <p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true"
                            severity="info"></p-button>
                    </div>
                </div>
                </div>

        <p-table #dt1 [value]="gstList" responsiveLayout="scroll" scrollHeight="650px" class="w-full m-5" styleClass="p-datatable-sm "
             [paginator]="true" [rows]="10" [(selection)]="selectedGST"  (onPage)="loadGST($event)" 
             [rowsPerPageOptions]="[10,15,20]">
            <ng-template pTemplate="header">
                <tr>
                    <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                    <!-- <th pSortableColumn="roleName">User Name <p-sortIcon field="RoleName"></p-sortIcon></th> -->
                    <th>HSN Code</th>
                    <th>Description Goods and Services</th>
                    <th>GST Rate (%)</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-gst>
                <tr>
                    <td>
                        <p-tableCheckbox [value]="gst"></p-tableCheckbox>
                    </td>
                    <td class="text-blue-500 underline" style="cursor: pointer;" (click)="edit(gst)">{{gst.hsnCode}}</td>
                    <td>{{gst.gstDescription}}</td>
                    <td>{{gst.gstRate | number: '1.2-2' }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="8">No Records found.</td>
                </tr>
            </ng-template>
        </p-table>


    </p-card>

    <!-- Create GST Dialog -->

    <p-dialog header="Add GST" [modal]="true" [(visible)]="visible" [style]="{width: '60vw'}" [draggable]="false"
        [resizable]="false">
        <form [formGroup]="createGSTForm">

            <div class="field col-12 flex justify-content-between align-items-center">
                <div>
                                @if (!isEdit) {
                <p-button label="Save" (onClick)="createGST()" icon="pi pi-save"
                    class="p-button-outlined" size="small"></p-button>
                }
                @else {
                <p-button label="Update" severity="info" (click)="update()"
                    icon="pi pi-arrow-circle-up" size="small"></p-button>
                }

                <p-button
                label="Cancel"
                severity="danger"
                class="p-button-outlined ml-2"
                icon="pi pi-times"
                size="small"
                (click)="cancelDialog()">
                </p-button>

                </div>
            
                <div>
                    <label class="block label-required" style="font-weight: bold;">Required Field</label>
                </div>
            
            </div>
            
   <div class="flex gap-3">
                        <div class="field text-left w-4">
                            <label class="label-required display">Type</label><br>
                           <!-- <div class="field text-left"> --><br>
                <div style="display: flex; gap: 2rem; align-items: center; margin-left: 15px;">
                   <label>
  <input type="radio" formControlName="IsServiceType" [value]="false" /> Goods
</label>

<label>
  <input type="radio" formControlName="IsServiceType" [value]="true" /> Service
</label>

                </div>

              <small
  *ngIf="submitted && formControls.IsServiceType.errors"
  class="text-red-500">
  Please select a type (Goods or Service).
</small>

                        </div>
                     
                    </div>
            <div class="grid mt-3">

                <div class="col">
    <div class="field text-left">
        <label class="label-required display">HSN Code</label>
        <input 
            pInputText 
            formControlName="HSNCode"    
            [readonly]="isEdit"  
            [ngClass]="{'ng-invalid ng-dirty': warn && createGSTForm.controls.HSNCode.errors}"
            class="w-full p-inputtext-sm" 
        />
    </div>
</div>

                <div class="col">
                    <div class="field text-left">
                        <label class="label-required display">Description</label>
                        <input pInputText formControlName="GSTDescription"
                            [ngClass]="{'ng-invalid ng-dirty': warn && createGSTForm.controls.GSTDescription.errors}"
                            class="w-full p-inputtext-sm" />
                    </div>
                </div>

            </div>
             <div class="grid mt-3">
                <div class="col">
                    <div class="field text-left">
                        <label class="label-required display">GST Rate (%)</label> 
                        <input pInputText formControlName="GSTRate" type="number" min="0"
                            [ngClass]="{'ng-invalid ng-dirty': warn && createGSTForm.controls.GSTRate.errors}"
                            class="w-full p-inputtext-sm" />
                    </div>
                </div>
<div class="col">
  <div class="field text-left">
    <label for="EffectiveFrom" class="label-required display">Effective Date</label>

    <p-calendar
      formControlName="EffectiveFrom"
      dateFormat="dd/mm/yy"
      [showIcon]="true"
      appendTo="body"
      placeholder="Select Date"
      styleClass="w-full"
      [ngClass]="{'ng-invalid ng-dirty': warn && createGSTForm.controls.EffectiveFrom.errors}"
    >
    </p-calendar>
    <small
      *ngIf="submitted && createGSTForm.controls.EffectiveFrom.errors"
      class="text-red-500">
      Required field.
    </small>
  </div>
</div>

            </div>




        </form>
    </p-dialog>

    <p-toast></p-toast>
    <p-confirmDialog></p-confirmDialog>
